var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35418 8C4.52375 7.26706 4 6.19469 4 5V2H3.5C2.94772 2 2.5 1.55228 2.5 1C2.5 0.447715 2.94772 0 3.5 0H12.5C13.0523 0 13.5 0.447715 13.5 1C13.5 1.55228 13.0523 2 12.5 2H12V5C12 6.19469 11.4762 7.26706 10.6458 8C11.4762 8.73294 12 9.80531 12 11V14H12.5C13.0523 14 13.5 14.4477 13.5 15C13.5 15.5523 13.0523 16 12.5 16H3.5C2.94772 16 2.5 15.5523 2.5 15C2.5 14.4477 2.94772 14 3.5 14H4V11C4 9.80531 4.52375 8.73294 5.35418 8ZM6 2H10V4L9.78885 4.10557C8.66274 4.66863 7.33726 4.66863 6.21115 4.10557L6 4V2ZM8 9C6.89543 9 6 9.89543 6 11V12L6.21115 11.8944C7.33726 11.3314 8.66274 11.3314 9.78885 11.8944L10 12V11C10 9.89543 9.10457 9 8 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrial);
export default __webpack_public_path__ + "static/media/trial.8e2cbdc947308a0c42792a25547a9d67.svg";
export { ForwardRef as ReactComponent };